import { render, staticRenderFns } from "./dot.vue?vue&type=template&id=5222ee6b&scoped=true"
import script from "./dot.vue?vue&type=script&lang=js"
export * from "./dot.vue?vue&type=script&lang=js"
import style0 from "./dot.vue?vue&type=style&index=0&id=5222ee6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5222ee6b",
  null
  
)

export default component.exports